// New header + footer around an OLD page (revamp plan task 22: "put the remaining
// public pages in the new shell, they keep their current content").
//
// Only the header and the footer sit inside .vl-revamp; the old page markup is
// rendered between them untouched, so the old CSS (Bootstrap, app.css) styles it
// exactly as before. Used by RouteWithHeader in src/Pages/index.js.
import React from "react";
import { SiteHeader } from "../components/site-header";
import { SiteFooter } from "../components/site-footer";
import { FaqBand } from "../components/faq-band";
import { useRevampShellSetup } from "./RevampShell";

export default function LegacyShell({ children }) {
  useRevampShellSetup();
  return (
    <>
      {/* vl-header-sticky (app.css): the wrapper itself must stick — QA row 23 */}
      <div className="vl-revamp vl-header-sticky bg-background text-foreground antialiased">
        <SiteHeader />
      </div>
      {children}
      <div className="vl-revamp bg-background text-foreground antialiased">
        <FaqBand />
        <SiteFooter />
      </div>
    </>
  );
}
